import { useEffect } from "react";

const DEFAULT_TITLE = "Alumni Registration";

const usePageTitle = (title: string): void => {
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
};

export default usePageTitle;
